if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if(this.querySelector(".loading__spinner")){
          this.querySelector(".loading__spinner").classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const productInfoElement = this.form.closest("product-info");
        const selectedIds = [];

        const idInput = this.form.querySelector("input[name='id']");
        const quantityInput = this.form.querySelector("input[name='quantity']");

        await new Promise((resolve) => setTimeout(resolve, 100));

        if (productInfoElement) {
          const selectedUpsellElements = productInfoElement.querySelectorAll(
            "quantity-break__upsell[data-selected='true']"
          );

          selectedUpsellElements.forEach((upsellElement) => {
            const productForm =
              upsellElement.querySelector("product-form form");
            if (productForm) {
              const upsellIdInput =
                productForm.querySelector("input[name='id']");
              if (upsellIdInput) {
                selectedIds.push({
                  id: upsellIdInput.value,
                  quantity: 1, // Default quantity for upsell items
                });
              }
            }
          });
        }
       
        try {
          if (selectedIds.length) {
            for (const item of selectedIds) {
              const upsellResponse = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: item.id,
                  quantity: item.quantity,
                }),
              });

              if (!upsellResponse.ok) {
                throw new Error(`Failed to add upsell product ${item.id}`);
              }

              const upsellData = await upsellResponse.json();
              console.log(`Added product ${item.id} to cart`, upsellData);
            }
          }

          config.body = formData;
          const response = await fetch(`${routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.getAll("id[]"),
              quantity: formData.getAll("quantity[]"),
              errors: data.errors || data.description,
              message: data.message,
            });

            this.handleErrorMessage(data.description);
            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const cartIconBubbleElement =
            document.getElementById("cart-icon-bubble");
          if (cartIconBubbleElement && data.sections["cart-icon-bubble"]) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = data.sections["cart-icon-bubble"];
            const svgNew = tempDiv.querySelector("svg");
            const imgNew = tempDiv.querySelector("img");
            const svgContainer = cartIconBubbleElement.querySelector("svg");
            const imgOld = cartIconBubbleElement.querySelector("img");

            if (svgNew) {
              if (svgContainer) {
                svgNew.innerHTML = svgContainer.innerHTML;
              }
              if (imgOld) {
                svgNew.outerHTML = `<img id="Outline" src="${imgOld.src}" alt="">`;
              }
            } else if (imgNew && svgContainer) {
              svgNew.innerHTML = svgContainer.innerHTML;
            }

            data.sections["cart-icon-bubble"] = tempDiv.innerHTML;
          }

          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(data);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(data);
          }
        } catch (error) {
          console.error("Error during cart submission:", error);
        } finally {
          this.submitButton.classList.remove("loading");
          if (this.cart?.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }
          if (!this.error) {
            this.submitButton.removeAttribute("aria-disabled");
          }
          this.querySelector(".loading__spinner").classList.add("hidden");

          const cartCountElement = document.querySelector(".cart-count-bubble");
          const parentElement = document.getElementById("cart-icon-bubble");
          if (cartCountElement && parentElement) {
            const newDiv = document.createElement("div");
            newDiv.classList.add("main_cart_bubble_count");
            newDiv.appendChild(cartCountElement);
            parentElement.appendChild(newDiv);
            const hiddenSpan = newDiv.querySelector(
              '.cart-count-bubble span[aria-hidden="true"]'
            );
            if (hiddenSpan) {
              hiddenSpan.parentElement.removeChild(hiddenSpan);
              newDiv.appendChild(hiddenSpan);
            }
          }

          const skipCartField = document.querySelector(
            'input.product-variant-id[data-skip-cart="true"]'
          );
          if (skipCartField) {
            window.location.href = "/checkout";
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
